import { useEffect, useState } from 'react';
import { Form, Button, Col, Row, Modal, Spinner } from 'react-bootstrap';
import {
  FaChevronDown,
  FaChevronUp,
  FaPlus,
  FaRegTrashAlt,
  FaEye,
  FaEraser,
  FaFileInvoiceDollar,
  FaBuilding,
  FaUserTie,
  FaBoxes,
  FaCreditCard,
  FaLink,
  FaCalculator,
  FaExclamationTriangle,
} from 'react-icons/fa';
import api from '../../api/apiweb-factura.js';
import Rut from 'rutjs';
import TIPOS_DOCUMENTO_REFERENCIA from '../../constants/tiposReferencia';
import { v4 as uuidv4 } from 'uuid';
import './Factura.scss';

function FacturaFormulario(props) {
  const initialState = {
    emisor: {
      rut: '', razonSocial: '', direccion: '', comuna: '', ciudad: '',
      tipoVenta: 'Del Giro', acteco: '', email: '', telefono: '', giro: '',
    },
    receptor: {
      rut: '', razonSocial: '', tipoCompra: 'Del Giro', direccion: '',
      comuna: '', ciudad: '', giro: '', contacto: '', rutSolicita: '',
    },
    productos: [],
    formaPago: '1',
    referencias: [],
    mostrarReferencias: false,
  };

  const [formData, setFormData] = useState(initialState);
  const [rutReceptorError, setRutReceptorError] = useState('');
  const [rutSolicitaError, setRutSolicitaError] = useState('');
  const [erroresReceptor, setErroresReceptor] = useState([]);
  const [mostrarModalErrores, setMostrarModalErrores] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorApi, setErrorApi] = useState(null);
  const [mostrarModalErrorApi, setMostrarModalErrorApi] = useState(false);
  const [erroresProducto, setErroresProducto] = useState([]);
  const [mostrarModalErroresProducto, setMostrarModalErroresProducto] = useState(false);
  const [mostrarModalReferenciaInvalida, setMostrarModalReferenciaInvalida] = useState(false);
  const [erroresReferencia, setErroresReferencia] = useState([]);
  const [mostrarModalPdf, setMostrarModalPdf] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [jsonPendienteEnvio, setJsonPendienteEnvio] = useState(null);
  const [inputsTemporales, setInputsTemporales] = useState({});
  const [actecoOpciones, setActecoOpciones] = useState([]);
  const [fechaEmision, setFechaEmision] = useState('');
  const [urlLogo, setUrlLogo] = useState('');

  const subtotal = Math.round(formData.productos.reduce((acc, producto) => {
    const cantidad = parseFloat(producto.cantidad || 0);
    const precio = parseFloat(producto.precio || 0);
    const descuento = parseFloat(producto.descuento || 0);
    const bruto = cantidad * precio;
    const descuentoItem = bruto * (descuento / 100);
    return acc + (bruto - descuentoItem);
  }, 0));

  const montoNeto = subtotal;
  const tasaIVA = 19;
  const montoIVA = Math.round(montoNeto * (tasaIVA / 100));
  const total = Math.round(montoNeto + montoIVA);

  const [visibleSections, setVisibleSections] = useState({
    emisor: true,
    receptor: true,
    transporte: true,
  });

  const eliminarReferencia = (index) => {
    const nuevasReferencias = [...formData.referencias];
    nuevasReferencias.splice(index, 1);
    setFormData((prev) => ({ ...prev, referencias: nuevasReferencias }));
  };

  const toggleSection = (section) => {
    setVisibleSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const handleInputChange = (e, section, field) => {
    const value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      [section]: { ...prev[section], [field]: value },
    }));
  };

  const actualizarProducto = (index, campo, valor) => {
    setFormData((prev) => {
      const nuevosProductos = [...prev.productos];
      nuevosProductos[index] = { ...nuevosProductos[index], [campo]: valor };
      return { ...prev, productos: nuevosProductos };
    });
  };

  const handleFormaPagoChange = (e) => {
    setFormData((prev) => ({ ...prev, formaPago: e.target.value }));
  };

  const handleLimpiarFormulario = () => {
    setFormData((prev) => ({
      ...initialState,
      emisor: { ...prev.emisor },
    }));
    setRutReceptorError('');
    setRutSolicitaError('');
    setErroresReceptor([]);
    setMostrarModalErrores(false);
  };

  const eliminarProducto = (index) => {
    const nuevosProductos = [...formData.productos];
    nuevosProductos.splice(index, 1);
    setFormData((prev) => ({ ...prev, productos: nuevosProductos }));
  };

  const agregarReferencia = () => {
    setFormData((prev) => ({
      ...prev,
      referencias: [...prev.referencias, { tipoDoc: '', folio: '', fecha: '', razon: '' }],
    }));
  };

  const actualizarReferencia = (index, campo, valor) => {
    const nuevasReferencias = [...formData.referencias];
    nuevasReferencias[index][campo] = valor;
    setFormData((prev) => ({ ...prev, referencias: nuevasReferencias }));
  };

  const generarJsonFactura = () => {
    const subtotal = formData.productos.reduce((acc, producto) => {
      const cantidad = parseFloat(producto.cantidad || 0);
      const precio = parseFloat(producto.precio || 0);
      const descuento = parseFloat(producto.descuento || 0);
      const totalSinDescuento = cantidad * precio;
      const montoDescontado = totalSinDescuento * (descuento / 100);
      return acc + (totalSinDescuento - montoDescontado);
    }, 0);

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    const fechaemisionDate = new Date(fechaEmision);
    const errores = [];
    if (fechaemisionDate > hoy) {
      errores.push('La fecha de emisión no puede ser mayor al día actual.');
      setMostrarModalErrores(true);
      setErroresReceptor(errores);
      return false;
    }
    if (fechaEmision === '') {
      errores.push('La fecha de emisión no puede ser nula.');
      setMostrarModalErrores(true);
      setErroresReceptor(errores);
      return false;
    }
    if (!validarReceptor()) return false;
    if (!validarProductos()) return false;
    if (!validarReferencias()) return false;

    const tasaIVA = 19;
    const iva = Math.round((subtotal * tasaIVA) / 100);
    const total = Math.round(subtotal + iva);

    const jsonGenerado = {
      ID: uuidv4(),
      Encabezado: {
        IdDoc: { TipoDTE: '33', FchEmis: fechaEmision, TpoTranCompra: '1', TpoTranVenta: '1', FmaPago: formData.formaPago },
        Emisor: {
          RUTEmisor: new Rut(formData.emisor.rut).rut,
          RznSoc: formData.emisor.razonSocial,
          GiroEmis: formData.emisor.giro,
          CorreoEmisor: formData.emisor.email,
          Acteco: formData.emisor.acteco,
          CdgSIISucur: '12345678',
          DirOrigen: formData.emisor.direccion,
          CmnaOrigen: formData.emisor.comuna,
          CiudadOrigen: formData.emisor.ciudad,
          TipoVenta: formData.emisor.tipoVenta,
          Telefono: formData.emisor.telefono,
        },
        Receptor: {
          RUTRecep: new Rut(formData.receptor.rut).rut,
          RznSocRecep: formData.receptor.razonSocial,
          GiroRecep: formData.receptor.giro,
          DirRecep: formData.receptor.direccion,
          CmnaRecep: formData.receptor.comuna,
          CiudadRecep: formData.receptor.ciudad,
          Contacto: formData.receptor.contacto,
          RutSolicita: formData.receptor.rutSolicita,
          TipoCompra: formData.receptor.tipoCompra,
        },
        Totales: { MntNeto: montoNeto, TasaIVA: tasaIVA, IVA: iva, MntTotal: total },
      },
      Detalle: formData.productos.map((producto, index) => {
        const cantidad = parseInt(producto.cantidad || 0);
        const precio = parseFloat(producto.precio || 0);
        const descuento = parseFloat(producto.descuento || 0);
        const montoSinDescuento = cantidad * precio;
        const montoDescuento = Math.round(montoSinDescuento * (descuento / 100));
        const montoFinal = montoSinDescuento - montoDescuento;
        const detalleItem = {
          NroLinDet: index + 1,
          NmbItem: producto.nombre,
          DscItem: producto.descripcion,
          QtyItem: cantidad,
          PrcItem: precio,
          UnmdItem: producto.unidad,
          MontoItem: montoFinal,
        };
        if (descuento > 0) {
          detalleItem.DescuentoPct = +descuento.toFixed(2);
          detalleItem.DescuentoMonto = montoDescuento;
        }
        return detalleItem;
      }),
      ...(formData.mostrarReferencias && formData.referencias.length > 0 && {
        Referencia: formData.referencias.map((referencia, index) => ({
          NroLinRef: index + 1,
          TpoDocRef: referencia.tipoDoc,
          FolioRef: referencia.folio,
          FchRef: referencia.fecha,
          RazonRef: referencia.razon,
        })),
      }),
    };
    return jsonGenerado;
  };

  const handleVisuavilizar = async () => {
    setLoading(true);
    try {
      const dte = generarJsonFactura();
      if (!dte) return;
      const json = { dte, preview: true };
      const response = await api.previewFactura(json);
      const byteCharacters = atob(response.data);
      const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);
      setJsonPendienteEnvio(json.dte);
      setMostrarModalPdf(true);
    } catch (error) {
      console.error('Error al previsualizar factura:', error.message);
      setErrorApi('Ocurrió un error al generar el PDF.');
      setMostrarModalErrorApi(true);
    } finally {
      setLoading(false);
    }
  };

  const validarReceptor = () => {
    const receptor = formData.receptor;
    const errores = [];
    const rutValido = new Rut(receptor.rut).validate();
    if (!rutValido) {
      errores.push('El RUT del receptor es inválido.');
      setRutReceptorError('RUT inválido');
    } else {
      setRutReceptorError('');
    }

    const camposObligatorios = [
      { campo: 'razonSocial', etiqueta: 'Razón Social' },
      { campo: 'tipoCompra', etiqueta: 'Tipo de Compra' },
      { campo: 'direccion', etiqueta: 'Dirección' },
      { campo: 'comuna', etiqueta: 'Comuna' },
      { campo: 'ciudad', etiqueta: 'Ciudad' },
      { campo: 'giro', etiqueta: 'Giro' },
    ];

    if (receptor.razonSocial.length > 100) errores.push('Razón Social no puede superar los 100 caracteres.');
    if (receptor.giro.length > 80) errores.push('Giro no puede superar los 80 caracteres.');
    if (receptor.contacto.length > 80) errores.push('Contacto no puede superar los 80 caracteres.');
    if (receptor.direccion.length > 70) errores.push('Dirección no puede superar los 70 caracteres.');
    if (receptor.comuna.length > 20) errores.push('Comuna no puede superar los 20 caracteres.');
    if (receptor.ciudad.length > 20) errores.push('Ciudad no puede superar los 20 caracteres.');

    camposObligatorios.forEach(({ campo, etiqueta }) => {
      if (!receptor[campo] || receptor[campo].trim() === '') {
        errores.push(`El campo "${etiqueta}" es obligatorio.`);
      }
    });

    if (receptor.rutSolicita && receptor.rutSolicita.trim() !== '') {
      const rutSolicitaValido = new Rut(receptor.rutSolicita).validate();
      if (!rutSolicitaValido) {
        errores.push('El RUT de quien solicita es inválido.');
        setRutSolicitaError('RUT inválido');
      } else {
        setRutSolicitaError('');
      }
    }

    if (errores.length > 0) {
      setErroresReceptor(errores);
      setMostrarModalErrores(true);
      return false;
    }
    return true;
  };

  const validarProductos = () => {
    const errores = [];
    formData.productos.forEach((producto, index) => {
      const numeroFila = index + 1;
      if (!producto.nombre || producto.nombre.trim() === '') errores.push(`Fila ${numeroFila}: El nombre del producto es obligatorio.`);
      if (producto.cantidad === undefined || isNaN(producto.cantidad) || parseFloat(producto.cantidad) <= 0) errores.push(`Fila ${numeroFila}: La cantidad debe ser un número mayor a 0.`);
      if (producto.precio === undefined || isNaN(producto.precio) || parseFloat(producto.precio) <= 0) errores.push(`Fila ${numeroFila}: El precio debe ser un número mayor a 0.`);
      if (producto.descuento !== undefined && (!/^\d{0,3}(\.\d{1,2})?$/.test(producto.descuento) || parseFloat(producto.descuento) > 100)) {
        errores.push(`Fila ${numeroFila}: El descuento debe ser un número entre 0 y 100 con hasta 2 decimales.`);
      }
    });
    if (errores.length > 0) {
      setErroresProducto(errores);
      setMostrarModalErroresProducto(true);
      return false;
    }
    return true;
  };

  const validarReferencias = () => {
    const errores = [];
    if (formData.mostrarReferencias === false) return true;
    formData.referencias.forEach((ref, index) => {
      const fila = index + 1;
      if (!ref.tipoDoc || ref.tipoDoc.trim() === '') errores.push(`Referencia ${fila}: El tipo de documento es obligatorio.`);
      if (!ref.folio || ref.folio.trim() === '') errores.push(`Referencia ${fila}: El folio es obligatorio.`);
      if (!ref.fecha || ref.fecha.trim() === '') {
        errores.push(`Referencia ${fila}: La fecha es obligatoria.`);
      } else {
        const fechaReferencia = new Date(ref.fecha);
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        if (fechaReferencia > hoy) errores.push(`Referencia ${fila}: La fecha no puede ser mayor al día actual.`);
      }
      if (ref.razon && ref.razon.length > 90) errores.push(`Referencia ${fila}: La razón no puede exceder los 90 caracteres.`);
    });
    if (errores.length > 0) {
      setErroresReferencia(errores);
      setMostrarModalReferenciaInvalida(true);
      return false;
    }
    return true;
  };

  const formatearMiles = (valor) => {
    if (typeof valor !== 'number' || isNaN(valor)) return '';
    const [enteros, decimales] = valor.toFixed(2).split('.');
    const miles = enteros.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return decimales !== '00' ? `${miles},${decimales}` : miles;
  };

  const handleRutReceptorChange = (e) => {
    const input = e.target.value;
    const limpio = input.replace(/[^0-9kK]/g, '');
    if (limpio === '') {
      setFormData((prev) => ({ ...prev, receptor: { ...prev.receptor, rut: '' } }));
      setRutReceptorError('');
      return;
    }
    try {
      const rutObj = new Rut(limpio);
      const rutFormateado = rutObj.getNiceRut();
      const esValido = rutObj.validate();
      setFormData((prev) => ({ ...prev, receptor: { ...prev.receptor, rut: rutFormateado } }));
      setRutReceptorError(esValido ? '' : 'RUT inválido');
    } catch (err) {
      setFormData((prev) => ({ ...prev, receptor: { ...prev.receptor, rut: input } }));
      setRutReceptorError('RUT inválido');
    }
  };

  const handleRutSolicitaChange = (e) => {
    const input = e.target.value;
    const limpio = input.replace(/[^0-9kK]/g, '');
    if (limpio === '') {
      setFormData((prev) => ({ ...prev, receptor: { ...prev.receptor, rutSolicita: '' } }));
      setRutSolicitaError('');
      return;
    }
    try {
      const rutObj = new Rut(limpio);
      const rutFormateado = rutObj.getNiceRut();
      const esValido = rutObj.validate();
      setFormData((prev) => ({ ...prev, receptor: { ...prev.receptor, rutSolicita: rutFormateado } }));
      setRutSolicitaError(esValido ? '' : 'RUT inválido');
    } catch (err) {
      setFormData((prev) => ({ ...prev, receptor: { ...prev.receptor, rutSolicita: input } }));
      setRutSolicitaError('RUT inválido');
    }
  };

  useEffect(() => {
    const cargarDatosEmpresa = async () => {
      if (props.empresas && props.empresas.length > 0) {
        const empresa = props.empresas[0];
        const nicerut = new Rut('' + empresa.rut, true).getNiceRut();
        if (empresa.logo != null) setUrlLogo(empresa.logo);
        try {
          const actecoData = (await api.getActeco()).data.records;
          const artecoOpc = actecoData.map((item) => ({ value: item.codigo, label: `${item.nombre}` }));
          setActecoOpciones(artecoOpc);
          setFormData((prev) => ({
            ...prev,
            emisor: {
              rut: nicerut || '',
              razonSocial: empresa.name || '',
              direccion: empresa.direccion || '',
              comuna: empresa.comuna || '',
              ciudad: empresa.ciudad || '',
              email: empresa.email || '',
              telefono: empresa.telefono || '',
              giro: empresa.giro || '',
              tipoVenta: empresa.tipoVenta || 'Del Giro',
              acteco: actecoData.length > 0 ? actecoData[0].codigo : '',
            },
          }));
        } catch (error) {
          console.error('Error al obtener Acteco:', error);
        }
      }
    };
    cargarDatosEmpresa();
  }, [props.empresas]);

  const handleEnviarFactura = async () => {
    await api.createFactura(jsonPendienteEnvio);
  };

  const SectionHeader = ({ section, icon, title }) => (
    <div className="section-header" onClick={() => toggleSection(section)} role="button">
      <div className="section-header-title">
        {icon}
        <span>{title}</span>
      </div>
      {visibleSections[section] ? <FaChevronUp /> : <FaChevronDown />}
    </div>
  );

  return (
    <div className="Factura">
      <div className="page-header">
        <h1 className="page-title">Factura Electrónica</h1>
        <p className="page-subtitle">Genera y previsualiza facturas electrónicas</p>
      </div>

      <div className="factura-summary-bar">
        <div className="factura-summary-logo">
          {urlLogo && <img src={urlLogo} alt="Logo" />}
        </div>
        <div className="factura-summary-info">
          <div className="factura-doc-type">Factura electrónica</div>
          <div className="factura-doc-rut">RUT {formData.emisor.rut || '—'}</div>
          <div className="factura-doc-folio">N° folio no asignado</div>
          <Form.Group className="factura-doc-fecha">
            <Form.Label>Fecha emisión</Form.Label>
            <Form.Control
              type="date"
              value={fechaEmision}
              onChange={(e) => setFechaEmision(e.target.value)}
            />
          </Form.Group>
        </div>
      </div>

      <div className="form-section">
        <SectionHeader section="emisor" icon={<FaBuilding />} title="Datos del Emisor" />
        {visibleSections.emisor && (
          <div className="form-section-body">
            <Row className="g-3">
              <Col md={8}>
                <Form.Label>Razón Social</Form.Label>
                <Form.Control type="text" value={formData.emisor.razonSocial} readOnly />
              </Col>
              <Col md={6}>
                <Form.Label>Dirección</Form.Label>
                <Form.Control type="text" value={formData.emisor.direccion} readOnly />
              </Col>
              <Col md={3}>
                <Form.Label>Comuna</Form.Label>
                <Form.Control type="text" value={formData.emisor.comuna} readOnly />
              </Col>
              <Col md={3}>
                <Form.Label>Ciudad</Form.Label>
                <Form.Control type="text" value={formData.emisor.ciudad} readOnly />
              </Col>
              <Col md={3}>
                <Form.Label>Teléfono</Form.Label>
                <Form.Control type="text" value={formData.emisor.telefono} readOnly />
              </Col>
              <Col md={5}>
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" value={formData.emisor.email} readOnly />
              </Col>
              <Col md={8}>
                <Form.Label>Giro</Form.Label>
                <Form.Control type="text" value={formData.emisor.giro} readOnly />
              </Col>
              <Col md={6}>
                <Form.Label>Tipo de Venta</Form.Label>
                <Form.Select
                  value={formData.emisor.tipoVenta}
                  onChange={(e) => handleInputChange(e, 'emisor', 'tipoVenta')}
                >
                  <option value="Del Giro">Del Giro</option>
                  <option value="Ventas que no son del Giro">Ventas que no son del giro</option>
                  <option value="Ventas de bienes inmuebles">Ventas de bienes inmuebles</option>
                </Form.Select>
              </Col>
              <Col md={6}>
                <Form.Label>Actividad económica</Form.Label>
                <Form.Select
                  value={formData.emisor.acteco || ''}
                  onChange={(e) => handleInputChange(e, 'emisor', 'acteco')}
                >
                  {actecoOpciones.map((item) => (
                    <option key={item.value} value={item.value}>{item.label}</option>
                  ))}
                </Form.Select>
              </Col>
            </Row>
          </div>
        )}
      </div>

      <div className="form-section">
        <SectionHeader section="receptor" icon={<FaUserTie />} title="Datos del Receptor" />
        {visibleSections.receptor && (
          <div className="form-section-body">
            <Row className="g-3">
              <Col md={4}>
                <Form.Label>RUT</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="12.345.678-9"
                  value={formData.receptor.rut}
                  onChange={handleRutReceptorChange}
                  isInvalid={!!rutReceptorError}
                />
                <Form.Control.Feedback type="invalid">{rutReceptorError}</Form.Control.Feedback>
              </Col>
              <Col md={8}>
                <Form.Label>Razón Social</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Razón Social"
                  value={formData.receptor.razonSocial}
                  onChange={(e) => handleInputChange(e, 'receptor', 'razonSocial')}
                  maxLength={100}
                />
              </Col>
              <Col md={6}>
                <Form.Label>Tipo de Compra</Form.Label>
                <Form.Select
                  value={formData.receptor.tipoCompra}
                  onChange={(e) => handleInputChange(e, 'receptor', 'tipoCompra')}
                >
                  <option value="Del Giro">Del Giro</option>
                  <option value="Del Giro">Supermercados</option>
                  <option value="Otro">Venta de Bienes inmuebles, 'BBRR'</option>
                  <option value="Del Giro">Activo Fijo</option>
                  <option value="Otro">IVA Uso Común</option>
                  <option value="Otro">IVA no Recuperable</option>
                  <option value="No Corresponde incluir">No Corresponde incluir</option>
                </Form.Select>
              </Col>
              <Col md={6}>
                <Form.Label>Dirección</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Dirección"
                  value={formData.receptor.direccion}
                  onChange={(e) => handleInputChange(e, 'receptor', 'direccion')}
                  maxLength={70}
                />
              </Col>
              <Col md={3}>
                <Form.Label>Comuna</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Comuna"
                  value={formData.receptor.comuna}
                  onChange={(e) => handleInputChange(e, 'receptor', 'comuna')}
                  maxLength={20}
                />
              </Col>
              <Col md={3}>
                <Form.Label>Ciudad</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Ciudad"
                  value={formData.receptor.ciudad}
                  onChange={(e) => handleInputChange(e, 'receptor', 'ciudad')}
                  maxLength={20}
                />
              </Col>
              <Col md={6}>
                <Form.Label>Contacto</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Contacto"
                  value={formData.receptor.contacto}
                  onChange={(e) => handleInputChange(e, 'receptor', 'contacto')}
                  maxLength={80}
                />
              </Col>
              <Col md={4}>
                <Form.Label>RUT Solicita</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="12.345.678-9"
                  value={formData.receptor.rutSolicita}
                  onChange={handleRutSolicitaChange}
                  isInvalid={!!rutSolicitaError}
                />
                <Form.Control.Feedback type="invalid">{rutSolicitaError}</Form.Control.Feedback>
              </Col>
              <Col md={8}>
                <Form.Label>Giro</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Giro"
                  value={formData.receptor.giro}
                  onChange={(e) => handleInputChange(e, 'receptor', 'giro')}
                  maxLength={80}
                />
              </Col>
            </Row>
          </div>
        )}
      </div>

      <div className="form-section">
        <div className="section-header section-header-static">
          <div className="section-header-title">
            <FaBoxes />
            <span>Productos</span>
            {formData.productos.length > 0 && (
              <span className="section-badge">{formData.productos.length}</span>
            )}
          </div>
        </div>
        <div className="form-section-body p-0">
          {formData.productos.length === 0 ? (
            <div className="empty-state">
              <FaBoxes className="empty-state-icon" />
              <p className="empty-state-text">No hay productos. Agrega al menos uno para emitir la factura.</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="data-table data-table-form">
                <thead>
                  <tr>
                    <th style={{ minWidth: 150 }}>Nombre</th>
                    <th style={{ minWidth: 180 }}>Descripción</th>
                    <th style={{ width: 110 }}>Cantidad</th>
                    <th style={{ width: 80 }}>Unidad</th>
                    <th style={{ width: 130 }}>Precio</th>
                    <th style={{ width: 100 }}>Desc. (%)</th>
                    <th className="text-end" style={{ width: 130 }}>Subtotal</th>
                    <th className="text-center" style={{ width: 60 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {formData.productos.map((producto, index) => (
                    <tr key={index}>
                      <td>
                        <Form.Control type="text" value={producto.nombre} maxLength={80}
                          onChange={(e) => actualizarProducto(index, 'nombre', e.target.value)} />
                      </td>
                      <td>
                        <Form.Control type="text" value={producto.descripcion} maxLength={1000}
                          onChange={(e) => actualizarProducto(index, 'descripcion', e.target.value)} />
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          value={inputsTemporales[index]?.cantidad ?? formatearMiles(producto.cantidad)}
                          onChange={(e) => {
                            const input = e.target.value;
                            if (!/^[\d.,]*$/.test(input)) return;
                            const sinPuntos = input.replace(/\./g, '').replace(',', '.');
                            if (/^(\d{0,12})(\.\d{0,2})?$/.test(sinPuntos)) {
                              setInputsTemporales((prev) => ({ ...prev, [index]: { ...prev[index], cantidad: input } }));
                            }
                          }}
                          onBlur={() => {
                            const valor = inputsTemporales[index]?.cantidad || '';
                            const numero = parseFloat(valor.replace(/\./g, '').replace(',', '.'));
                            if (!isNaN(numero)) {
                              actualizarProducto(index, 'cantidad', numero);
                              setInputsTemporales((prev) => ({ ...prev, [index]: { ...prev[index], cantidad: formatearMiles(numero) } }));
                            }
                          }}
                          onFocus={() => {
                            setInputsTemporales((prev) => ({
                              ...prev,
                              [index]: { ...prev[index], cantidad: producto.cantidad?.toString().replace('.', ',') || '' },
                            }));
                          }}
                        />
                      </td>
                      <td>
                        <Form.Control type="text" value={producto.unidad} maxLength={4}
                          onChange={(e) => actualizarProducto(index, 'unidad', e.target.value)} />
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          value={inputsTemporales[index]?.precio ?? formatearMiles(producto.precio)}
                          onChange={(e) => {
                            const input = e.target.value;
                            if (!/^[\d.,]*$/.test(input)) return;
                            const sinPuntos = input.replace(/\./g, '').replace(',', '.');
                            if (/^(\d{0,12})(\.\d{0,2})?$/.test(sinPuntos)) {
                              setInputsTemporales((prev) => ({ ...prev, [index]: { ...prev[index], precio: input } }));
                            }
                          }}
                          onBlur={() => {
                            const valor = inputsTemporales[index]?.precio || '';
                            const numero = parseFloat(valor.replace(/\./g, '').replace(',', '.'));
                            if (!isNaN(numero)) {
                              actualizarProducto(index, 'precio', numero);
                              setInputsTemporales((prev) => ({ ...prev, [index]: { ...prev[index], precio: formatearMiles(numero) } }));
                            }
                          }}
                          onFocus={() => {
                            setInputsTemporales((prev) => ({
                              ...prev,
                              [index]: { ...prev[index], precio: producto.precio?.toString().replace('.', ',') || '' },
                            }));
                          }}
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          value={producto.descuento === 0 ? '' : producto.descuento}
                          onChange={(e) => {
                            const input = e.target.value;
                            if (/^\d{0,3}([.,]\d{0,2})?$/.test(input) || input === '') {
                              actualizarProducto(index, 'descuento', input);
                            }
                          }}
                          onBlur={(e) => {
                            let valor = e.target.value.replace(',', '.');
                            let numero = parseFloat(valor);
                            if (isNaN(numero) || numero < 0) numero = 0;
                            if (numero > 100) numero = 100;
                            actualizarProducto(index, 'descuento', +numero.toFixed(2));
                          }}
                        />
                      </td>
                      <td className="text-end subtotal-cell">
                        {formatearMiles(
                          Math.round(parseFloat(
                            producto.cantidad * producto.precio *
                            (1 - parseFloat(producto.descuento || 0) / 100),
                          )),
                        )}
                      </td>
                      <td className="text-center">
                        <Button
                          variant="outline-danger"
                          size="sm"
                          title="Eliminar producto"
                          onClick={() => eliminarProducto(index)}
                          className="row-action-btn"
                        >
                          <FaRegTrashAlt />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <div className="form-section-action">
            <Button
              variant="primary"
              onClick={() =>
                setFormData((prev) => ({
                  ...prev,
                  productos: [...prev.productos, { nombre: '', descripcion: '', cantidad: 1, unidad: '', precio: 0, descuento: 0 }],
                }))
              }
            >
              <FaPlus className="me-2" />Agregar producto
            </Button>
          </div>
        </div>
      </div>

      <div className="form-section">
        <div className="section-header section-header-static">
          <div className="section-header-title">
            <FaCreditCard />
            <span>Forma de Pago</span>
          </div>
        </div>
        <div className="form-section-body">
          <Row>
            <Col md={6}>
              <Form.Select value={formData.formaPago} onChange={handleFormaPagoChange}>
                <option value="1">Contado</option>
                <option value="2">Crédito</option>
                <option value="3">Sin Costo</option>
              </Form.Select>
            </Col>
          </Row>
        </div>
      </div>

      <div className="form-section">
        <div className="section-header section-header-static">
          <div className="section-header-title">
            <FaLink />
            <span>Referencias</span>
            {formData.mostrarReferencias && formData.referencias.length > 0 && (
              <span className="section-badge">{formData.referencias.length}</span>
            )}
          </div>
          <Form.Check
            type="switch"
            id="ref-switch"
            label="Activar"
            checked={formData.mostrarReferencias}
            onChange={(e) => setFormData((prev) => ({ ...prev, mostrarReferencias: e.target.checked }))}
          />
        </div>
        {formData.mostrarReferencias && (
          <div className="form-section-body p-0">
            {formData.referencias.length === 0 ? (
              <div className="empty-state">
                <FaLink className="empty-state-icon" />
                <p className="empty-state-text">Sin referencias agregadas</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="data-table data-table-form">
                  <thead>
                    <tr>
                      <th style={{ minWidth: 180 }}>Tipo de Documento</th>
                      <th style={{ width: 130 }}>Folio Ref.</th>
                      <th style={{ width: 160 }}>Fecha Ref.</th>
                      <th>Razón Referencia</th>
                      <th className="text-center" style={{ width: 60 }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData.referencias.map((referencia, index) => (
                      <tr key={index}>
                        <td>
                          <Form.Select
                            value={referencia.tipoDoc || ''}
                            onChange={(e) => actualizarReferencia(index, 'tipoDoc', e.target.value)}
                          >
                            <option value="">Seleccionar</option>
                            {TIPOS_DOCUMENTO_REFERENCIA.map((tipo) => (
                              <option key={tipo.value} value={tipo.value}>{tipo.label}</option>
                            ))}
                          </Form.Select>
                        </td>
                        <td>
                          <Form.Control type="text" placeholder="Folio" maxLength={18}
                            value={referencia.folio || ''}
                            onChange={(e) => actualizarReferencia(index, 'folio', e.target.value)} />
                        </td>
                        <td>
                          <Form.Control type="date"
                            value={referencia.fecha || ''}
                            onChange={(e) => actualizarReferencia(index, 'fecha', e.target.value)} />
                        </td>
                        <td>
                          <Form.Control type="text" placeholder="Razón" maxLength={90}
                            value={referencia.razon || ''}
                            onChange={(e) => actualizarReferencia(index, 'razon', e.target.value)} />
                        </td>
                        <td className="text-center">
                          <Button
                            variant="outline-danger"
                            size="sm"
                            title="Eliminar referencia"
                            onClick={() => eliminarReferencia(index)}
                            className="row-action-btn"
                          >
                            <FaRegTrashAlt />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <div className="form-section-action">
              <Button variant="primary" onClick={agregarReferencia}>
                <FaPlus className="me-2" />Agregar referencia
              </Button>
            </div>
          </div>
        )}
      </div>

      <div className="form-section">
        <div className="section-header section-header-static">
          <div className="section-header-title">
            <FaCalculator />
            <span>Totales</span>
          </div>
        </div>
        <div className="form-section-body">
          <div className="totals-grid">
            <div className="total-row">
              <span className="total-label">Sub Total</span>
              <span className="total-value">{formatearMiles(subtotal)}</span>
            </div>
            <div className="total-row">
              <span className="total-label">Monto Neto</span>
              <span className="total-value">{formatearMiles(montoNeto)}</span>
            </div>
            <div className="total-row">
              <span className="total-label">IVA ({tasaIVA}%)</span>
              <span className="total-value">{formatearMiles(montoIVA)}</span>
            </div>
            <div className="total-row total-row-grand">
              <span className="total-label">Total</span>
              <span className="total-value">${formatearMiles(total)}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="factura-actions">
        <Button variant="outline-secondary" onClick={handleLimpiarFormulario}>
          <FaEraser className="me-2" />Limpiar
        </Button>
        <Button variant="primary" onClick={handleVisuavilizar} disabled={loading}>
          <FaEye className="me-2" />Validar y visualizar
        </Button>
      </div>

      {/* Modales */}
      <Modal show={mostrarModalErrores} onHide={() => setMostrarModalErrores(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FaExclamationTriangle className="text-warning me-2" />
            Errores en los datos
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul className="error-list">
            {erroresReceptor.map((error, index) => <li key={index}>{error}</li>)}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarModalErrores(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={mostrarModalErroresProducto} onHide={() => setMostrarModalErroresProducto(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FaExclamationTriangle className="text-warning me-2" />
            Errores en productos
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul className="error-list">
            {erroresProducto.map((error, index) => <li key={index}>{error}</li>)}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarModalErroresProducto(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={loading} centered backdrop="static">
        <Modal.Body className="text-center py-4">
          <Spinner animation="border" variant="primary" className="mb-3" />
          <p className="m-0 modal-message">Cargando previsualización…</p>
        </Modal.Body>
      </Modal>

      <Modal show={mostrarModalReferenciaInvalida} onHide={() => setMostrarModalReferenciaInvalida(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FaExclamationTriangle className="text-warning me-2" />
            Errores en referencias
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul className="error-list">
            {erroresReferencia.map((error, i) => <li key={i}>{error}</li>)}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setMostrarModalReferenciaInvalida(false)}>Entendido</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={mostrarModalErrorApi} onHide={() => setMostrarModalErrorApi(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FaExclamationTriangle className="text-danger me-2" />
            Error al enviar la factura
          </Modal.Title>
        </Modal.Header>
        <Modal.Body><p className="m-0">{errorApi}</p></Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarModalErrorApi(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={mostrarModalPdf} onHide={() => setMostrarModalPdf(false)} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FaFileInvoiceDollar className="me-2 text-primary" />
            Previsualización de factura
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          {pdfUrl ? (
            <iframe
              src={pdfUrl}
              title="Vista previa de factura"
              width="100%"
              height="800px"
              style={{ border: 'none', display: 'block' }}
            />
          ) : (
            <div className="loading-inline"><Spinner animation="border" variant="primary" /><p>Cargando PDF…</p></div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarModalPdf(false)}>Cancelar</Button>
          <Button variant="primary" onClick={handleEnviarFactura}>
            Confirmar y enviar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default FacturaFormulario;
